import styled from '@emotion/styled';
import { DASH_COLORS, DASH_FONTS, DASH_TYPE } from '../../dashboardTokens';

// Shared pieces of the module summary views (specs/workshop-dashboard.md →
// "Module summary views — design guidance").

// Challenges red, opportunities green — the lens module's split colors.
export const OBSTACLE_COLOR = DASH_COLORS.error;
export const OPPORTUNITY_COLOR = DASH_COLORS.accent;

// Summary body text: between meta and label scale.
export const SUMMARY_TEXT = 'clamp(15px, 2.4vmin, 58px)';

export const Dot = styled.i`
  flex: 0 0 auto;
  width: 0.9em;
  height: 0.9em;
  border-radius: 50%;
  background: ${({ color }) => color || DASH_COLORS.textDim};
`;

export const SummaryList = styled.ul`
  list-style: none;
  margin: 0;
  padding: 0;
  display: flex;
  flex-direction: column;
  gap: clamp(6px, 0.9vmin, 22px);
  min-height: 0;
  overflow: hidden;
`;

export const SummaryRow = styled.li`
  display: flex;
  align-items: center;
  gap: clamp(8px, 1vmin, 24px);
  font-size: ${SUMMARY_TEXT};
  color: ${DASH_COLORS.text};
  min-width: 0;

  .clip {
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
  .dim { color: ${DASH_COLORS.textDim}; }
  .num { font-family: ${DASH_FONTS.numeric}; font-weight: 700; margin-left: auto; }
`;

export const SectionHeading = styled.h3`
  display: flex;
  align-items: center;
  gap: 0.5em;
  margin: clamp(14px, 2vmin, 40px) 0 clamp(6px, 1vmin, 20px);
  font-size: ${DASH_TYPE.meta};
  font-weight: 700;
  letter-spacing: 0.07em;
  text-transform: uppercase;
  color: ${DASH_COLORS.textDim};

  &:first-of-type { margin-top: 0; }
`;

/** Multi-line clamp for participant-written text (titles can be paragraphs). */
export const ClampedText = styled.span`
  display: -webkit-box;
  -webkit-line-clamp: ${({ lines = 2 }) => lines};
  -webkit-box-orient: vertical;
  overflow: hidden;
`;
